import { render } from "./PaywallDashboardGrid.vue?vue&type=template&id=2b28b7f5"
import script from "./PaywallDashboardGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallDashboardGrid.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/PaywallDashboardGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b28b7f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b28b7f5', __exports__)) {
    api.reload('2b28b7f5', __exports__)
  }
  
  module.hot.accept("./PaywallDashboardGrid.vue?vue&type=template&id=2b28b7f5", () => {
    api.rerender('2b28b7f5', render)
  })

}


export default __exports__